// extracted by mini-css-extract-plugin
export default {"flyoutMenuItem":"FlyoutMenuItem-flyoutMenuItem--3425c"};